export default {
  name: "info",
  class: "h-6 w-6 text-blue-400",
  box: 24,
  svg: `<path
  stroke-linecap="round"
  stroke-linejoin="round"
  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="fillcolor"
/>`,
};
